/* DOM ELEMENTS */

//PAGE HEADER
export const pageHeader = $("#masthead");
export const pageMain = $("#site-content");
export const pageFooter = $("#colophon");
